{
    "onetoone": {
        "Hepsi": "Hepsi",
        "Baslik": "One to One",
        "Kullanici": "Kullanıcı",
        "Tarih": "Tarih",
        "Durum": "Durum",
        "Yil": "Yıl",
        "Ay": "Ay",
        "Gorus": "Görüş",
        "Not": "Not",
        "HedefRandevu": "Hedef Randevu",
        "YapilanRandevu": "Yapılan Randevu",
        "HedefReferans": "Hedef Referans",
        "YapilanReferans": "Yapılan Referans",
        "Urun": "Ürün",
        "Hedef": "Hedef",
        "Yapilan": "Yapılan",
        "Temizle": "Temizle",
        "Arama": "Arama",
        "Ara": "Ara",
        "Kapat": "Kapat",
        "Kaydet": "Kayıt",
        "KaydetKapat": "Kayıt-Kapat",
        "Yenile": "Yenile",
        "YeniEkle": "Yeni Ekle",
        "Olustur": "Oluştur",
        "Seciniz": "Seçiniz",
        "Bekliyor": "Görüş Bekleniyor",
        "GorusAldi": "Cevap Yazıldı",
        "Tamamlandi": "Kapalı",
        "Iptal": "İptal",
        "EminMisiniz": "Emin misiniz?",
        "SilmeMesaj": "Bunu geri alamazsınız!",
        "Sil": "Sil"
    }
}
